import { useSelector } from 'react-redux';
import { teamsModel } from '../../teams/model';
import { useCurrentPlan } from './useCurrentPlan';
import { subscriptionLimits } from '@distribute/shared/types';
import { checkAIExceed } from '../lib';
export const useSubscriptionLimits = () => {
  const plan = useCurrentPlan();

  return subscriptionLimits[plan.id];
};

export const useAIExceed = () => {
  const { aiMonthlyResponsesCount: count } = useSelector(
    teamsModel.selectors.selectUserTeamMemberDataWithError
  );
  const { maxAIMonthlyResponsesCount } = useSubscriptionLimits();

  return checkAIExceed(maxAIMonthlyResponsesCount, count);
};
